import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spacing',
  templateUrl: './spacing.component.html',
  styleUrls: ['./spacing.component.sass']
})
export class SpacingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
